module.exports = __webpack_public_path__ + "static/media/visa.9deb0022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/footer/components/Info/static/img/visa.svg
// module id = 2066
// module chunks = 118